import { tr } from '@/lib/i18n-core';
import type { AdmissionVital } from './types';

export interface VitalReading {
  key: string;
  label: string;
  value: string;
}

export function vitalsLine(vital: AdmissionVital | undefined): VitalReading[] {
  if (!vital) return [];
  const readings: (VitalReading | null)[] = [
    vital.bpSystolic ? { key: 'bp', label: tr('ipd', 'bp'), value: `${vital.bpSystolic}/${vital.bpDiastolic ?? '—'}` } : null,
    vital.pulse ? { key: 'pulse', label: tr('ipd', 'pulse'), value: String(vital.pulse) } : null,
    vital.temperatureC ? { key: 'temp', label: tr('ipd', 'temp'), value: `${vital.temperatureC} °C` } : null,
    vital.spo2 ? { key: 'spo2', label: tr('ipd', 'spo'), value: `${vital.spo2}%` } : null,
    vital.respiratoryRate ? { key: 'rr', label: tr('ipd', 'ws_respiratory_rate'), value: String(vital.respiratoryRate) } : null,
  ];
  return readings.filter((reading): reading is VitalReading => reading !== null);
}
